import { BellIcon } from "@heroicons/react/24/outline";
import { Popover } from "@headlessui/react";
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import MobileNavigationItems from "./MobileNavigationItems";

const MobileMenu = ({ navigation, user, userNavigation }) => {
  if (!user) return null;

  return (
    <Popover.Panel as="nav" className="lg:hidden" aria-label="Global">
      <div className="border-t border-gray-200 pt-4">
        <MobileNavigationItems
          navigation={navigation}
        />
        <div className="max-w-3xl mx-auto px-4 flex items-center sm:px-6">
          <div className="flex-shrink-0">
            <img
              className="h-10 w-10 rounded-full"
              src={user.avatarUrl}
              alt=""
            />
          </div>
          <div className="ml-3">
            <div className="text-base font-medium text-gray-800">
              {user.fullname}
            </div>
            <div className="text-sm font-medium text-gray-500">
              {user.email}
            </div>
          </div>
          {/* <button
            type="button"
            className="ml-auto flex-shrink-0 bg-white rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
          >
            <span className="sr-only">View notifications</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </button> */}
        </div>
        <div className="mt-3 max-w-3xl mx-auto px-2 space-y-1 sm:px-4">
          {userNavigation.map(({ name, ...props }) => (
            <NavLink
              key={name}
              {...props}
              end
              className={({ isActive }) => classNames(
                "block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900",
                { "bg-gray-200 hover:bg-gray-200": props.to && isActive }
              )}
            >
              {name}
            </NavLink>
          ))}
        </div>
      </div>

      {/* <div className="mt-6 max-w-3xl mx-auto px-4 sm:px-6">
        <a
          href="#"
          className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-rose-600 hover:bg-rose-700"
        >
          New Publication
        </a>
      </div> */}
    </Popover.Panel>
  );
};

export default MobileMenu;
